<script setup lang="ts">
import MainBreadcrumbs from "../../../ui/components/header/MainBreadcrumbs.vue";
import { ref, onMounted } from "vue";
import { useCampaignPlannerStore } from "../store";

const store = useCampaignPlannerStore();

onMounted(() =>
	store.setBreadcrumbs([
		{ title: "Screens", disabled: true, to: "/campaign-planner/screens" },
	])
);

type tabsType = {
	itemId: string;
	translationKey: string;
	icon: string;
	to: string;
	visible: boolean;
};

const tabs: tabsType[] = [
	{
		itemId: "Screens",
		translationKey: "campaign_planner.tabs.screens",
		icon: "fa-billboard",
		to: "/campaign-planner/screens/listing",
		visible: true,
	},
	{
		itemId: "Sizing",
		translationKey: "campaign_planner.tabs.sizing",
		icon: "fa-ruler-triangle",
		to: "/campaign-planner/screens/sizing",
		visible: true,
	},
	{
		itemId: "Grouping",
		translationKey: "campaign_planner.tabs.grouping",
		icon: "fa-layer-group",
		to: "/campaign-planner/screens/grouping",
		visible: true,
	},
];

const activeTab = ref(null);
</script>

<template>
	<main-breadcrumbs :breadcrumbs="store.breadcrumbs" />

	<v-tabs v-model="activeTab" center-active show-arrows>
		<v-tab
			v-for="tab in tabs"
			v-show="tab.visible"
			:key="tab.itemId"
			:value="tab.itemId"
			color="primary"
			:to="tab.to"
		>
			<i :class="`fa-duotone ${tab.icon} fa-lg`"></i>
			<div class="tab-text">
				{{ $t(tab.translationKey) }}
			</div>
		</v-tab>
	</v-tabs>
	<v-divider />
	<div>
		<router-view />
	</div>
</template>

<style lang="scss">
.tab-text {
	margin-left: 10px;
}

.card-border-right {
	border-left: 50px solid rgb(var(--v-theme-borderColor));
}
</style>
